import { CreatorBrand, QuicksPicksBrand } from 'constants/brands';
import React from 'react';
import {
    Nav,
    MusicNote,
    SearchOutlined,
    HeadphonesOutlined,
    ProductPluginsOutlined,
    useBreakpoint,
    ArchiveOutlined,
    MaestroComponent,
    IconProps,
    ProductHeader,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { RoutePaths } from 'types/enums';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { getIsCurrentPath } from 'helpers';
import { CONFIG } from 'utils/config';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';

const usePublicNavigation = () => {
    const toLocalizedPath = useToLocalizedPath();

    const forYou = {
        path: toLocalizedPath('/'),
        text: t`For you`,
        icon: MusicNote,
    };

    const search = {
        path: toLocalizedPath(`/${RoutePaths.Browse}`),
        text: t`Search`,
        icon: SearchOutlined,
    };

    const quickPicks = {
        path: toLocalizedPath(`/${RoutePaths.QuickPicks}`),
        text: QuicksPicksBrand,
        icon: ArchiveOutlined,
    };

    const creator = {
        path: toLocalizedPath(`/${RoutePaths.CreatorBeatMaker}`),
        text: CreatorBrand,
        icon: HeadphonesOutlined,
        isBrowserOnly: true,
    };

    const plugin = {
        path: CONFIG.VITE_SAMPLES_PLUGIN_URL,
        text: t`Plugin`,
        icon: ProductPluginsOutlined,
        isBrowserOnly: true,
        target: '_blank',
    };

    type Route = {
        path: string;
        text: string;
        icon: MaestroComponent<IconProps, Record<string, any>>;
        isBrowserOnly?: boolean;
        target?: React.HTMLAttributeAnchorTarget;
    };

    const forYouRoutes: Route[] = [forYou, search, quickPicks, creator, plugin];

    const showIcon = useBreakpoint('md');

    const publicRoutes = forYouRoutes;

    return { showIcon, publicRoutes };
};

export const PublicNavigation = ({
    onClick,
    isDAWPlugin,
}: {
    onClick: () => void;
    isDAWPlugin: boolean;
}) => {
    const { publicRoutes, showIcon } = usePublicNavigation();

    return (
        <ProductHeader.Nav key="public">
            {publicRoutes
                .filter(({ isBrowserOnly }) =>
                    isDAWPlugin ? !isBrowserOnly : true,
                )
                .map((props) => (
                    <Nav.Link
                        key={props.path}
                        as={RouterLink}
                        to={props.path}
                        icon={showIcon && props.icon}
                        onClick={onClick}
                        isCurrent={getIsCurrentPath(props.path)}
                        target={props?.target}
                    >
                        {props.text}
                    </Nav.Link>
                ))}
        </ProductHeader.Nav>
    );
};
